import React from 'react';

// A lazy-loaded chunk 404s whenever a new build is deployed while an old tab is open
// (chunk hashes change). Detect that and recover by pulling the fresh build.
const isChunkLoadError = (error) =>
  !!error &&
  (error.name === 'ChunkLoadError' ||
    /Loading chunk [\w-]+ failed/i.test(error.message || '') ||
    /ChunkLoadError/i.test(error.message || ''));

// Reload at most once per 10s so a genuinely-missing chunk can't cause an infinite loop.
const reloadOnceForChunk = () => {
  try {
    const last = parseInt(window.sessionStorage.getItem('chunkReloadAt') || '0', 10);
    if (Date.now() - last > 10000) {
      window.sessionStorage.setItem('chunkReloadAt', String(Date.now()));
      window.location.reload();
      return true;
    }
  } catch (e) {
    /* sessionStorage unavailable — skip auto-reload */
  }
  return false;
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    if (isChunkLoadError(error)) {
      reloadOnceForChunk();
      return { hasError: true }; // render nothing while the page reloads
    }
    if (error.message && error.message.includes('ResizeObserver loop completed')) {
      return { hasError: true }; // hide error
    }
    return null;
  }

  componentDidCatch(error, info) {
    console.error('Error caught by boundary:', error);
  }

  render() {
    if (this.state.hasError) {
      return null; // or fallback UI
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
